exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-bar{width:100%;height:44px;box-shadow:0 2px 10px 0 rgba(0,0,0,.1);background-color:#fff;position:relative;z-index:1000}.nav-bar .btn-back{height:100%;position:absolute;top:0;left:10px}.nav-bar .arrow-back{width:8px;height:16px;float:left;margin-top:14px;margin-right:15px}.nav-bar .title{width:100%;text-align:center;font-size:16px;line-height:46px;color:#666}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-74ed018d","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./demo/components/NavBar.vue
// module id = 37
// module chunks = 0